// multi-form.js (sorted version)
document.addEventListener("DOMContentLoaded", function () {
  // ------- Utilities & Feature Flags -------
  const tabs = document.querySelectorAll(".tabs-navigation .tab");
  const tabContents = document.querySelectorAll(".tab-content");
  const discountBar = document.getElementById("discount-bar");
  const checkoutButton = document.getElementById("checkout-button");
  let totalSelectedProducts = 0;
  const localCart = {}; // lineItemKey -> quantity
  const variantToKeyMap = {}; 
  let isUIBusy = false;
  let lastCartSync = 0;
  let lastAddTime = 0;
  const cartQueue = [];
  let isProcessingQueue = false;
  let lastRequestTime = 0;


    async function throttleRequests() {
      const now = Date.now();
      const diff = now - lastRequestTime;

      if (diff < 300) {
        await new Promise(r => setTimeout(r, 300 - diff));
      }

      lastRequestTime = Date.now();
    }

    function enqueue(job) {
      cartQueue.push(job);
      processQueue();
    }

    async function processQueue() {
      if (isProcessingQueue || !cartQueue.length) return;

      isProcessingQueue = true;
      setUIState(true); // ✅ LOCK UI HERE

      while (cartQueue.length) {
        const job = cartQueue.shift();

        try {
          await job();
        } catch (err) {
          console.warn("Job failed:", err);
        }
      }

      isProcessingQueue = false;
      setUIState(false); // ✅ UNLOCK ONLY HERE
    }

    async function rebuildKeyMapFromCart() {
        try {
          const res = await fetch("/cart.js");
          const cart = await res.json();

          // ✅ SAFE CLEAR
          Object.keys(variantToKeyMap).forEach(k => delete variantToKeyMap[k]);

          cart.items.forEach(item => {
            const variantId = item.variant_id;
            const sellingPlan = item.selling_plan_allocation?.selling_plan_id;
            const mapKey = `${variantId}_${sellingPlan || "one-time"}`;

            if (!variantToKeyMap[mapKey]) {
              variantToKeyMap[mapKey] = [];
            }

            variantToKeyMap[mapKey].push(item.key);
          });

        } catch (e) {
          console.warn("Failed to rebuild key map", e);
        }
    }

  function setUIState(loading) {
    isUIBusy = loading;

    const buttons = document.querySelectorAll(".add-to-cart, .increase, .decrease");

    buttons.forEach(btn => {
      btn.style.pointerEvents = loading ? "none" : "auto";
      btn.style.opacity = loading ? "0.6" : "1";
    });
  }

  // login fallback (read from server-rendered body attribute if present)
  if (typeof window.__isCustomerLoggedIn === 'undefined') {
    try {
      const bodyAttr = document.body && document.body.getAttribute && document.body.getAttribute('data-customer-logged-in');
      window.__isCustomerLoggedIn = (bodyAttr === 'true');
    
    } catch (e) {
      window.__isCustomerLoggedIn = false;
    
    }
  }

  function safeNormalizeTag(t) {
    return (t || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\+/g, ' plus ')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function persistDietPreferencesArray(arr) {
    try {
      const cleaned = (arr || []).map(v => (v||'').toString().trim()).filter(Boolean);
      if (cleaned.length) sessionStorage.setItem('dietaryPreferences', cleaned.join(','));
      else sessionStorage.removeItem('dietaryPreferences');
    } catch (e) {
      console.warn('persistDietPreferencesArray error', e);
    }
  }

  function getDietPreferencesArray() {
    try {
      const raw = sessionStorage.getItem('dietaryPreferences') || '';
      if (!raw) return [];
      return raw.split(',').map(s => s.trim()).filter(Boolean);
    } catch (e) {
      console.warn('getDietPreferencesArray error', e);
      return [];
    }
  }

  function getEatingTypePreference() {
    try {
      const checked = document.querySelector('input[name="eating"]:checked');
      if (checked && checked.value) {
        let v = checked.value.toString().trim().toLowerCase();
        if (v === 'family') v = 'family friendly'; // 👈 add this mapping
        return v;
      }
      // return sessionStorage.getItem('eatingTypePreference');
      const saved = sessionStorage.getItem('eatingTypePreference');
      if (saved === 'family') return 'family friendly';
      return saved;

    } catch (e) {
      return null;
    }
  }

  async function savePreferencesToCartAttribute(arr) {
    try {
      if (!arr || !arr.length) return;
      const payload = { attributes: { 'Dietary Preferences': arr.join(',') } };
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
       
        return;
      }
      const json = await res.json();
     
    } catch (e) {
      console.warn('[multi-form] savePreferencesToCartAttribute failed', e);
    }
  }

  // read dietary preferences stored in cart attributes (server-side -> cart.attributes)
  async function fetchPrefsFromCartAttribute() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      if (!res.ok) return [];
      const cart = await res.json();
      const raw = (cart && cart.attributes && cart.attributes['Dietary Preferences']) || '';
      if (!raw) return [];
      return raw.split(',').map(s => s.trim()).filter(Boolean);
    } catch (e) {
      console.warn('fetchPrefsFromCartAttribute error', e);
      return [];
    }
  }

  // -------------------------
  // APPLY RECOMMENDATIONS & SORTING (ENTIRE GRID & TOP)
function applyRecommendationsFromPrefsArray(prefsArray) {
  try {
    // Normalizer (consistent for prefs and tags)
    function normalizeWhole(s) {
      if (!s) return '';
      return s.toString()
        .toLowerCase()
        .replace(/\+/g, ' plus ')
        .replace(/[-_]+/g, ' ')
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    // Cleanup previous UI
    document.querySelectorAll('.recommended-badge[data-generated="true"]').forEach(el => el.remove());
    document.querySelectorAll('.best-match-badge[data-generated="true"]').forEach(el => el.remove());
    document.querySelectorAll('.recommended-header').forEach(el => el.remove());
    document.querySelectorAll('.top-recommended-item').forEach(clone => {
      try { if (clone.__origObserver) clone.__origObserver.disconnect(); } catch(e){}
      clone.remove();
    });

    const topGrid = document.getElementById('top-recommended');
    if (topGrid) topGrid.innerHTML = '';
    const topWrapper = document.getElementById('top-recommended-wrapper');
    if (topWrapper) topWrapper.style.display = 'none';

    // Prepare normalized prefs
    const prefsNormalized = (prefsArray || []).map(p => normalizeWhole(p)).filter(Boolean);
    if (!prefsNormalized.length) {
      document.querySelectorAll('.product-card').forEach(c => {
        c.classList.remove('recommended', 'best-match');
        delete c.dataset.matchScore;
      });
      
      return;
    }

    const prefsCount = prefsNormalized.length;

    // Evaluate all product cards
    const productCards = Array.from(document.querySelectorAll('.product-card'));
    productCards.forEach((card, idx) => {
      const rawTags = (card.getAttribute('data-tags') || '')
        .split(',')
        .map(t => {
          t = t.trim().toLowerCase();
          if (t === 'family') return 'family friendly';
          return t;
        })
        .filter(Boolean);
      const normalizedTagSet = new Set(rawTags.map(t => normalizeWhole(t)));

      let score = 0;
      prefsNormalized.forEach(pref => {
        if (normalizedTagSet.has(pref)) score++;
      });

      card.dataset.matchScore = String(score);
      card.dataset.matchTotal = String(prefsCount);
      card.dataset._originalIndex = String(idx);

      // Clear previous badges
      card.querySelectorAll('[data-generated="true"]').forEach(el => el.remove());
      card.classList.remove('best-match', 'recommended');

      // Decide which badge to show
      if (prefsCount >= 2) {
        if (score === prefsCount && score > 0) {
          card.classList.add('best-match', 'recommended');
          const best = document.createElement('div');
          best.className = 'best-match-badge';
          best.setAttribute('data-generated', 'true');
          Object.assign(best.style, {
            position: 'absolute', top: '12px', left: '12px',
            background: '#FFD700', color: '#000',
            padding: '4px 8px', borderRadius: '12px',
            fontSize: '12px', fontWeight: '700'
          });
          best.innerText = 'Best match';
          if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
          card.appendChild(best);
        } else if (score > 0) {
          card.classList.add('recommended');
          const rec = document.createElement('div');
          rec.className = 'recommended-badge';
          rec.setAttribute('data-generated', 'true');
          Object.assign(rec.style, {
            position: 'absolute', top: '12px', right: '12px',
            background: '#008060', color: '#fff',
            padding: '6px 8px', borderRadius: '4px', fontSize: '12px'
          });
          rec.innerText = 'Recommended';
          if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
          card.appendChild(rec);
        }
      } else {
        // Single preference: any match is Best match
        if (score > 0) {
          card.classList.add('best-match', 'recommended');
          const best = document.createElement('div');
          best.className = 'best-match-badge';
          best.setAttribute('data-generated', 'true');
          Object.assign(best.style, {
            position: 'absolute', top: '12px', left: '12px',
            background: '#FFD700', color: '#000',
            padding: '4px 8px', borderRadius: '12px',
            fontSize: '12px', fontWeight: '700'
          });
          best.innerText = 'Best match';
          if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
          card.appendChild(best);
        }
      }
    });

    // Comparator (sort by match quality)
    function cardComparator(a, b) {
      const sa = +a.dataset.matchScore || 0;
      const sb = +b.dataset.matchScore || 0;
      if (sb !== sa) return sb - sa;
      const ta = +a.dataset.matchTotal || 1;
      const tb = +b.dataset.matchTotal || 1;
      const ra = sa / ta, rb = sb / tb;
      if (rb !== ra) return rb > ra ? 1 : -1;
      const oa = +a.dataset._originalIndex || 0;
      const ob = +b.dataset._originalIndex || 0;
      return oa - ob;
    }

    // Reorder product grids
    document.querySelectorAll('.product-grid').forEach(grid => {
      const cards = Array.from(grid.querySelectorAll('.product-card'));
      if (!cards.length) return;
      const sorted = cards.slice().sort(cardComparator);
      let changed = false;
      sorted.forEach((c, i) => { if (c !== cards[i]) changed = true; });
      if (changed) {
        cards.forEach(c => grid.removeChild(c));
        sorted.forEach(c => grid.appendChild(c));
      }
    });

    // Build top recommended grid (Best/Recommended pills)
    if (topGrid) {
      const all = Array.from(document.querySelectorAll('.product-card')).filter(c => +c.dataset.matchScore > 0);
      all.sort(cardComparator);
      const topToShow = all.slice(0, 8);
      topGrid.innerHTML = '';

      topToShow.forEach(origCard => {
        const clone = origCard.cloneNode(true);
        clone.classList.add('top-recommended-item');
        clone.style.position = 'relative';
        clone.style.cursor = 'pointer';

        // Determine status
        const isBest = origCard.classList.contains('best-match');
        const label = isBest ? 'Best match' : 'Recommended';
        const color = isBest ? '#FFD700' : '#008060';
        const textColor = isBest ? '#000' : '#fff';

        // Replace match-pill with styled badge
        const pill = document.createElement('div');
        pill.className = 'match-pill';
        Object.assign(pill.style, {
          position: 'absolute',
          left: '12px',
          top: '12px',
          background: color,
          color: textColor,
          padding: '5px 9px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '600',
          boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
        });
        pill.innerText = label;
        clone.appendChild(pill);

        // Remove old badges from clone
        clone.querySelectorAll('[data-generated="true"]').forEach(el => el.remove());

        // Keep quantity controls in sync
        const origAdd = origCard.querySelector('.add-to-cart');
        const origInc = origCard.querySelector('.increase');
        const origDec = origCard.querySelector('.decrease');
        const cloneAdd = clone.querySelector('.add-to-cart');
        const cloneInc = clone.querySelector('.increase');
        const cloneDec = clone.querySelector('.decrease');

        if (cloneAdd && origAdd) cloneAdd.addEventListener('click', e => { e.stopPropagation(); origAdd.click(); });
        if (cloneInc && origInc) cloneInc.addEventListener('click', e => { e.stopPropagation(); origInc.click(); });
        if (cloneDec && origDec) cloneDec.addEventListener('click', e => { e.stopPropagation(); origDec.click(); });

        // Sync via MutationObserver
        const observer = new MutationObserver(() => {
          const oq = origCard.querySelector('.quantity-selector');
          const cq = clone.querySelector('.quantity-selector');
          if (oq && cq) {
            cq.style.display = oq.style.display;
            const n = oq.querySelector('.quantity')?.textContent;
            if (n && cq.querySelector('.quantity')) cq.querySelector('.quantity').textContent = n;
          }
        });
        observer.observe(origCard, { childList: true, subtree: true });
        clone.__origObserver = observer;

        // Scroll to original card on click
        clone.addEventListener('click', e => {
          if (e.target.closest('.add-to-cart') || e.target.closest('.increase') || e.target.closest('.decrease')) return;
          origCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const img = origCard.querySelector('.product-image');
          if (img) img.click();
        });

        topGrid.appendChild(clone);
      });

      if (topWrapper) topWrapper.style.display = topToShow.length ? 'block' : 'none';
    //  if (topWrapper) topWrapper.style.display = topToShow.length ? 'none' : 'none';
    }

  } catch (err) {
    console.error('applyRecommendationsFromPrefsArray failed:', err);
  }
}


// expose to window so we can call it from console/tests
window.applyRecommendationsFromPrefsArray = applyRecommendationsFromPrefsArray;


  // ------- single showStep function -------
  function showStep(index, persist = true) {
    if (!tabs || !tabContents) return;
    if (index < 0 || index >= tabContents.length) return;
    tabContents.forEach((content) => content.classList.remove("active"));
    tabs.forEach((tab) => tab.classList.remove("active"));
    tabContents[index].classList.add("active");
    tabs[index].classList.add("active");
    if (persist) {
      try { sessionStorage.setItem("multiStepCurrent", index.toString()); }
      catch (e) { console.warn('Could not persist multiStepCurrent', e); }
    }
    // trigger discount UI recalculation
    try { handleStepChange(); } catch(e){}
  }

  // ------- ZIP input (step1) -------
  const allowedZipRanges = [
    { start: 1000, end: 1990 }, // Lisboa
   // { start: 2750, end: 2765 }, // Cascais
  //  { start: 2780, end: 2795 }, // Oeiras
  //  { start: 2700, end: 2720 }, // Amadora
  //  { start: 2675, end: 2675 }, // Odivelas
  //  { start: 2670, end: 2670 }, // Loures
  //  { start: 2710, end: 2710 }, // Sintra
  ];

  for (let i = 1300; i <= 1400; i++) allowedZipRanges.push({ start: i, end: i });

  const allowedZips = [
    2750, 2765, 2645, 2775, 2785, //Cascais
    2635, 2735, 2745, //Sintra
    2780, 2770, 2740, 2730, 2760, 2790, 1495, 2795, //Oeiras
    2720, 2610, 2700, //Amadora 
    2650, 1685, 2620, 1675, 2675, //Odivelas
    2685, 2680, 2695, //Sacavém
    1000, 1050, 1070, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1500, 1600, 1700, 1750, 1805, 1885, 1900, 1950, //Lisboa
    7200, 7250, 7700 // Rosarios
  ];

  const zipInput = document.getElementById("zip-code");
  const zipResult = document.getElementById("zip-result");
  const continueStep1 = document.getElementById("continue-step-1");
  if (zipInput) {
    zipInput.addEventListener("input", function () {
      const zipCode = zipInput.value.trim();
      const prefix = parseInt((zipCode.split("-")[0] || "").replace(/\D/g, ""), 10);
      const isValid = !isNaN(prefix) && allowedZips.includes(prefix);
      const isValid2 = !isNaN(prefix) && allowedZipRanges.some(range => prefix >= range.start && prefix <= range.end);
      if (isValid || isValid2) {
        zipResult.textContent = window.translations?.success_message || "Valid";
        zipInput.style.border = "1px solid #4CAF50";
        zipResult.className = "success";
        zipResult.style.display = "block";
        if (continueStep1) continueStep1.style.display = "inline-block";
      } else {
        zipResult.textContent = window.translations?.error_message || "Not served";
        zipResult.className = "error";
        zipInput.style.border = "1px solid red";
        zipResult.style.display = "block";
        if (continueStep1) continueStep1.style.display = "none";
      }
    });
  }
  if (continueStep1) continueStep1.addEventListener("click", () => showStep(1, true));

  // ------- Discount bar helpers -------
  function updateDiscountMessage() {
      const currentLang = window.location.pathname.startsWith("/pt") ? "pt" : "en";

      const messages = {
        en: {
          chooseMin: "Please choose a minimum of 3 Meals",
          addMore: (c) => `Add ${c} more Meals`,
          freeDelivery: (c) => `Add ${c} more Meals and your delivery will be free.`,
          extraDiscount: (c) => `Add ${c} more Meals and get an extra discount of 10%`,
          congratulations: "Congratulations! Free delivery + 10% discount!"
        },
        pt: {
          chooseMin: "Por favor, escolha um mínimo de 3 refeições",
          addMore: (c) => `Adicione mais ${c} refeições`,
          freeDelivery: (c) => `Adicione mais ${c} refeições e o seu pedido será entregue gratuitamente.`,
          extraDiscount: (c) => `Adicione mais ${c} refeições e receba um desconto extra de 10%`,
          congratulations: "Parabéns! Entrega grátis + desconto de 10%!"
        }
      };

      let msg;

      if (totalSelectedProducts === 0) msg = messages[currentLang].chooseMin;
      else if (totalSelectedProducts < 3) msg = messages[currentLang].addMore(3 - totalSelectedProducts);
      else if (totalSelectedProducts < 6) msg = messages[currentLang].freeDelivery(6 - totalSelectedProducts);
      else if (totalSelectedProducts < 9) msg = messages[currentLang].extraDiscount(9 - totalSelectedProducts);
      else msg = messages[currentLang].congratulations;

      if (discountBar) discountBar.textContent = msg;

      if (checkoutButton) {
        const visible = totalSelectedProducts >= 3;
        checkoutButton.style.transform = visible ? "translateX(-50%) translateY(0)" : "translateY(100%)";
        checkoutButton.style.opacity = visible ? "1" : "0";
        checkoutButton.style.bottom = visible ? "60px" : "20px";
      }
  }
  function handleStepChange() {
    const selectProductsStep = document.getElementById("step-5") || document.getElementById("step-4");
    if (selectProductsStep && selectProductsStep.classList.contains("active")) {
      discountBar.style.display = "block";
      updateDiscountMessage();
    } else {
      discountBar.style.display = "none";
    }
  }

  // ------- Cart actions (add/increase/decrease) -------
  function initializeCartActions() {
    document.querySelectorAll(".add-to-cart").forEach(button => {
      button.addEventListener("click", function () {
        if (isUIBusy) return;
          setUIState(true);
        const originalText = this.innerHTML;
        this.innerHTML = `Adding <span class="spinner"></span>`;
        const cartActions = this.closest(".cart-actions");
        if (!cartActions) return;

        const variantId = parseInt(cartActions.dataset.productId, 10);

        const purchaseType = "onetime";

        // ✅ UI update immediately
        totalSelectedProducts++;
        updateDiscountMessage();

        this.style.display = "none";
        cartActions.querySelector(".quantity-selector").style.display = "flex";

        const bundlerDiscountProperties = {
          bundler_discount: "volume_discount",
          free_shipping: (totalSelectedProducts >= 6) ? "true" : "false"
        };

        const payload = {
          id: variantId,
          quantity: 1,
          properties: bundlerDiscountProperties
        };
      
        const buttonRef = this; // ✅ preserve reference

        enqueue(async () => {
          try {
            await new Promise(r => setTimeout(r, 50));
            await throttleRequests();

            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload)
            });

            if (!res.ok) {
              throw new Error(await res.text());
            }

            const data = await res.json();

            // ✅ SUCCESS → restore UI properly
            buttonRef.innerHTML = originalText;

            // switch to quantity UI
            buttonRef.style.display = "none";
            cartActions.querySelector(".quantity-selector").style.display = "flex";

          } catch (err) {
            console.error("Add failed:", err);

            // ❗ restore UI even on error
            buttonRef.innerHTML = originalText;
            buttonRef.style.display = "block";
          }
        });    
      });
    });
  }

  function initializeQuantityButtons() {
    document.addEventListener("click", function (e) {

      const incBtn = e.target.closest(".increase");
      const decBtn = e.target.closest(".decrease");

      if (!incBtn && !decBtn) return;

      // ✅ BLOCK if UI busy
      if (isUIBusy) return;
      const button = incBtn || decBtn;

      // ✅ mark loading (per button)
      if (button.dataset.loading === "true") return;
      button.dataset.loading = "true";

      const originalHTML = button.innerHTML;
      button.innerHTML = originalHTML;

      try {
        const cartActions = button.closest(".cart-actions");
        if (!cartActions) throw new Error("Missing cart-actions");

        const variantId = parseInt(cartActions.dataset.productId, 10);
        const qtyEl = cartActions.querySelector(".quantity");

        if (!variantId || !qtyEl) throw new Error("Missing data");

        let currentQty = parseInt(qtyEl.textContent || "1", 10);
        let newQty = incBtn ? currentQty + 1 : Math.max(0, currentQty - 1);

        if (newQty === currentQty) {
            button.classList.remove("loading");
            button.dataset.loading = "false";
            return;
        }

        // ✅ UI instant update
        if (newQty === 0) {
          cartActions.querySelector(".quantity-selector").style.display = "none";
          cartActions.querySelector(".add-to-cart").style.display = "block";
        } else {
          qtyEl.textContent = newQty;
        }

        totalSelectedProducts += (newQty - currentQty);
        updateDiscountMessage();

        setUIState(true);
        const buttonRef = button; // preserve reference

        enqueue(async () => {
          try {
            await new Promise(r => setTimeout(r, 50));
            await throttleRequests();

            const res = await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                updates: { [variantId]: newQty },
                attributes: {
                  free_shipping: totalSelectedProducts >= 6 ? "true" : ""
                }
              })
            });

            if (!res.ok) {
              throw new Error(await res.text());
            }
            await res.json();
          } catch (err) {
            console.error("Update failed:", err);
          } finally {
              buttonRef.innerHTML = originalHTML;
              buttonRef.dataset.loading = "false";
              buttonRef.classList.remove("loading"); // ✅ IMPORTANT (you added class earlier)
              setUIState(false); // ✅ unlock UI
            }
        });

      } catch (err) {
         console.error("Quantity error:", err);
      }

    });
  }

  async function restoreCartUI() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;

      const cart = await res.json();

      totalSelectedProducts = 0;

      cart.items.forEach(item => {
        const variantId = item.variant_id;
        const qty = item.quantity;

        totalSelectedProducts += qty;

        const cards = document.querySelectorAll(`.cart-actions[data-product-id="${variantId}"]`);

        cards.forEach(card => {
          const purchaseType = document.querySelector('input[name="purchase_type"]:checked')?.value;

          const isSubscription = !!item.selling_plan_allocation;

          if (purchaseType === "weekly" && !isSubscription) return;
          if (purchaseType !== "weekly" && isSubscription) return;

          const addBtn = card.querySelector(".add-to-cart");
          const qtySelector = card.querySelector(".quantity-selector");
          const qtyEl = card.querySelector(".quantity");

          if (addBtn && qtySelector && qtyEl) {
            addBtn.style.display = "none";
            qtySelector.style.display = "flex";
            qtyEl.textContent = item.quantity;
          }
        });
        // ✅ rebuild key map (important for updates)
        const sellingPlan = item.selling_plan_allocation?.selling_plan_id || "one-time";
        const mapKey = `${variantId}_${sellingPlan}`;

        if (!variantToKeyMap[mapKey]) {
          variantToKeyMap[mapKey] = [];
        }
        variantToKeyMap[mapKey].push(item.key);
      });

      updateDiscountMessage();

    } catch (err) {
      console.warn("restoreCartUI failed", err);
    }
  }

  let lastCartFetchTime = 0;
  let isFetchingCart = false;

  async function syncWithCart() {
    const now = Date.now();

    // ❌ prevent spam (1 request per 500ms)
    if (now - lastCartFetchTime < 2000 || isFetchingCart) return;

    isFetchingCart = true;
    lastCartFetchTime = now;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const hasSubscription = cart.items.some(i => i.selling_plan_allocation);
      if (hasSubscription) {
        const weeklyRadio = document.querySelector('input[name="purchase_type"][value="weekly"]');
        if (weeklyRadio) {
          weeklyRadio.checked = true;
          weeklyRadio.dispatchEvent(new Event("change"));
        }
      } else {
        const oneTimeRadio = document.querySelector('input[name="purchase_type"][value="one-time"]');
        if (oneTimeRadio) {
          oneTimeRadio.checked = true;
          oneTimeRadio.dispatchEvent(new Event("change"));
        }
      }
      totalSelectedProducts = (cart.items || [])
        .reduce((sum, it) => sum + (it.quantity || 0), 0);

      updateDiscountMessage();

    } catch (err) {
      console.warn("syncWithCart skipped (likely 429)", err);
    }
  }


  // ------- Sidebar product image slider (unchanged behavior) ------- 
  (function setupProductSlider() {
    const productImages = document.querySelectorAll('.product-image');
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('overlay');
    const closeSidebarBtn = document.getElementById('close-sidebar');
    const closeSidebarIcon = document.getElementById('close-sidebaricon');
    const sliderImage = document.getElementById('slider-image');
    const productTitle = document.getElementById('product-title');
    const productPrice = document.getElementById('product-price');
    const productDescription = document.getElementById('product-description');
    let currentIndex = 0;
    let currentImages = [];

    productImages.forEach(image => {
      image.addEventListener('click', function () {
        const card = image.closest('.product-card');
        const title = image.getAttribute('data-title') || "";
        const price = image.getAttribute('data-price') || "";
        const description = card?.querySelector('.hidden-description')?.innerHTML || "";
        try { currentImages = JSON.parse(image.getAttribute('data-images') || '[]'); } catch (e) { currentImages = []; }
        currentIndex = 0;
        if (sliderImage && currentImages[0]) sliderImage.src = currentImages[0];
        if (productTitle) productTitle.innerText = title;
        if (productPrice) productPrice.innerText = price;
        if (productDescription) productDescription.innerHTML = description;
        if (sidebar) sidebar.classList.add('visible');
        if (overlay) overlay.style.display = 'block';
      });
    });

    function updateSliderImage(direction = 'next') {
      const sImg = document.getElementById('slider-image');
      if (!sImg || currentImages.length === 0) return;
      const animationClass = direction === 'next' ? 'slide-left' : 'slide-right';
      sImg.classList.add(animationClass);
      setTimeout(() => {
        sImg.src = currentImages[currentIndex];
        sImg.classList.remove(animationClass);
        sImg.classList.add('fade-in');
        setTimeout(() => sImg.classList.remove('fade-in'), 500);
      }, 200);
    }
    document.getElementById('prev-btn')?.addEventListener('click', () => {
      if (currentImages.length === 0) return;
      currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      updateSliderImage('prev');
    });
    document.getElementById('next-btn')?.addEventListener('click', () => {
      if (currentImages.length === 0) return;
      currentIndex = (currentIndex + 1) % currentImages.length;
      updateSliderImage('next');
    });
    closeSidebarBtn?.addEventListener('click', () => { document.getElementById('sidebar')?.classList.remove('visible'); overlay && (overlay.style.display = 'none'); });
    closeSidebarIcon?.addEventListener('click', () => { document.getElementById('sidebar')?.classList.remove('visible'); overlay && (overlay.style.display = 'none'); });
    overlay?.addEventListener('click', () => { document.getElementById('sidebar')?.classList.remove('visible'); overlay && (overlay.style.display = 'none'); });
  })();

  // ------- Proceed to checkout -------
  const proceedToCheckout = document.getElementById("checkout-button");

  if (proceedToCheckout) {
    proceedToCheckout.addEventListener("click", function(e) {

      e.preventDefault();
      e.stopPropagation();

      const purchaseTypeEl = document.querySelector('input[name="purchase_type"]:checked');

      if (!purchaseTypeEl) {
        const warning = document.getElementById("purchase-warning");
        if (warning) warning.style.display = "block";

        document.querySelector(".purchase-toggle").scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        return;
      }

      sessionStorage.setItem("multiStepCurrent", "1");
      window.location.href = "/cart";
    });
  }

  // ------- Initialize cart actions + sync -------
  initializeCartActions();
  initializeQuantityButtons();

  // ⏳ slight delay to avoid race conditions
  setTimeout(() => {
    restoreCartUI();
  }, 300);

  // ✅ ADD THIS HERE
  window.addEventListener("pageshow", function () {
    restoreCartUI();
  });
  // ------- CART PAGE: force product-selection to open at step=5 on any "continue shopping" click -------
  try {
    const isOnCartPage = (window.location.pathname === '/cart' || window.location.pathname === '/pt/cart');
    if (isOnCartPage) {

      // Update existing anchors in DOM
      document.querySelectorAll('a[href*="/pages/product-selection"], a[data-href*="/pages/product-selection"], [data-href*="/pages/product-selection"]').forEach(el => {
        try {
          const raw = el.getAttribute('href') || el.getAttribute('data-href') || el.dataset?.href;
          if (!raw) return;
          const url = new URL(raw, window.location.origin);
          url.searchParams.set('step', '5');
          const newPath = url.pathname + url.search;
          if (el.hasAttribute('href')) el.setAttribute('href', newPath);
          if (el.hasAttribute('data-href')) el.setAttribute('data-href', newPath);
          if (el.dataset) el.dataset.href = newPath;
        } catch (err) { /* ignore malformed hrefs */ }
      });

      // Capture-phase click listener: intercept clicks before theme scripts
      document.body.addEventListener('click', function (e) {
        try {
          const el = e.target.closest && e.target.closest('a, button, [data-href], [data-url], [data-action], [formaction]');
          if (!el) return;
          const raw = (el.getAttribute && (el.getAttribute('href') || el.getAttribute('data-href') || el.getAttribute('data-url') || el.getAttribute('data-action') || el.getAttribute('formaction')))
                    || el.dataset?.href || el.dataset?.url || el.dataset?.action || '';
          if (!raw || !raw.includes('/pages/product-selection')) return;
          e.preventDefault();
          e.stopImmediatePropagation && e.stopImmediatePropagation();
          try {
            const u = new URL(raw, window.location.origin);
            u.searchParams.set('step', '5');
            window.location.href = u.pathname + u.search;
          } catch (err) {
            window.location.href = '/pages/product-selection?step=2';
          }
        } catch (outer) { console.warn('[multi-form] cart-click-handler error', outer); }
      }, true); // capture
    }
  } catch (e) { console.warn('cart -> product-selection rewrite failed', e); }

  // ------- default show step (unless preserved) and safe auto-jump -------
  const saved = parseInt(sessionStorage.getItem("multiStepCurrent") || '-1', 10);

  if (saved >= 0) {
    showStep(saved, false);
  } else {
    showStep(0, false);
  }

  (async function safeAutoJump() {
    try {
      const params = new URLSearchParams(window.location.search);
      const stepParam = params.get('step');
      const savedIndex = parseInt(sessionStorage.getItem('multiStepCurrent') || '-1', 10);
      const isLoggedIn = (window.__isCustomerLoggedIn === true || window.__isCustomerLoggedIn === 'true');

      // If logged in: always show pick meals (index 4) and apply saved prefs
      if (isLoggedIn) {
        let diets = getDietPreferencesArray();
        if (!diets.length) diets = await fetchPrefsFromCartAttribute();
        const eat = sessionStorage.getItem('eatingTypePreference');
        const combined = eat ? [...diets, eat] : [...diets];
        /*if (combined.length) {
          persistDietPreferencesArray(diets);
          applyRecommendationsFromPrefsArray(combined);
        }*/
        showStep(1, false);
        return;
      }


      // Guests: if no step param just apply client-side prefs if present
      if (!stepParam) {
        const saved = parseInt(sessionStorage.getItem("multiStepCurrent") || "-1", 10);
        if (saved >= 0) {
          showStep(saved, false);
        }
        return;
      }

      const targetIndex = Math.max(0, parseInt(stepParam, 10) - 1);
      let allow = false;
      if (!isNaN(savedIndex) && savedIndex >= targetIndex) allow = true;

      if (!allow) {
        try {
          const u = new URL(window.location.href);
          u.searchParams.set('step','1');
          window.history.replaceState({}, '', u.toString());
        } catch(e){}
        showStep(0, false);
      } else {
        showStep(targetIndex, false);
        /*const prefs = getDietPreferencesArray();
        if (prefs.length) applyRecommendationsFromPrefsArray(prefs);*/
        const diets = getDietPreferencesArray();
        const eat = sessionStorage.getItem('eatingTypePreference');
        const combined = eat ? [...diets, eat] : [...diets];
        /*if (combined.length) 
          applyRecommendationsFromPrefsArray(combined);*/
              }
      } catch (e) { console.warn('safeAutoJump error', e); }
  })();

  // If user came from homepage, remove saved progress (prevents accidental jumps)
  try {
    if (document.referrer) {
      const r = new URL(document.referrer);
      if (r.pathname === '/' || r.pathname === '/index.html') { 
        sessionStorage.removeItem('multiStepCurrent');
      }
    }
  } catch(e){}

      function restoreSelections() {
      // Restore diet
      const savedDiet = getDietPreferencesArray();
      if (savedDiet.length) {
        savedDiet.forEach(val => {
          const el = document.querySelector(`input[name="diet"][value="${val}"]`);
          if (el) el.checked = true;
        });
      }

      // Restore eating
      const savedEat = sessionStorage.getItem('eatingTypePreference');
      if (savedEat) {
        const el = document.querySelector(`input[name="eating"][value="${savedEat}"]`);
        if (el) el.checked = true;
      }
    }

       document.getElementById('go-back').addEventListener('click', function() {
        const tabs = Array.from(document.querySelectorAll('.tab-content'));
        const currentIndex = tabs.findIndex(tab => tab.classList.contains('active'));

        if (currentIndex > 0) {
          showStep(currentIndex - 1, true);
          restoreSelections();
        }
      });

      const radios = document.querySelectorAll('input[name="purchase_type"]');
      const benefitsList = document.getElementById("benefits-list");

      const weeklyBenefits = [
        "✔ Optimize Your Food Routine",
        "✔ Save time for what really matters",
        "✔ Unlock exclusive rewards",
        "✔ Access to our Epicurean community — limited to 200 members."
      ];

      const oneTimeBenefits = [
        "✖ Optimize Your Food Routine",
        "✖ Save time for what really matters",
        "✖ Unlock exclusive rewards",
        "✖ Access to our Epicurean community — limited to 200 members."
      ];

      radios.forEach(radio => {
        radio.addEventListener("change", function() {

          let benefits = this.value === "weekly" ? weeklyBenefits : oneTimeBenefits;

          benefitsList.innerHTML = benefits.map(item => `<li>${item}</li>`).join("");

        });
      });

function updateProductPrices() {
  document
    .querySelectorAll(".product-card")
    .forEach(card => {
      const priceEl =
        card.querySelector(".discounted-price");

      if (!priceEl) return;

      let original =
        priceEl.getAttribute(
          "data-original-price"
        );

      if (!original) {
        original = priceEl.innerText;
        priceEl.setAttribute(
          "data-original-price",
          original
        );
      }

      priceEl.innerHTML = original;
    });
}

updateProductPrices();
});